import { createFileRoute, redirect } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";

// Real dead URL found in Google Search Console's "Not found (404)" report
// (2026-09-26): homeapproach.com/homebuyer-checklist has no live route, but
// the real content it once pointed at is confirmed live at
// /blog/ultimate-first-time-homebuyer-checklist-2026 (see src/data/articles.ts).
// 301 so Google retires the dead URL and passes its signals to the real post.
export const Route = createFileRoute("/homebuyer-checklist")({
  head: () => seoHead("/homebuyer-checklist"),
  beforeLoad: () => {
    throw redirect({
      to: "/blog/$slug",
      params: { slug: "ultimate-first-time-homebuyer-checklist-2026" },
      replace: true,
      statusCode: 301,
    });
  },
});
